// eslint-disable-next-line no-unused-vars
import styles from "../../../../styles/selectBar.css";

const WorksheetSelectBar = ({ typeSelect, setTypeSelect }) => {
  return (
    <select
      id="typeSelect"
      value={typeSelect}
      onChange={(e) => setTypeSelect(e.target.value)}
      style={{
        padding: "10px",
        paddingLeft: "15px",
        fontSize: "16px",
        color: "#737373",
        width: "180px",
        border: "1px solidrgb(29, 22, 22)",
        borderRadius: "5px",
        cursor: "pointer",
        backgroundColor: "white",
      }}
      className="customSelect"
    >
      <option value="all">학습지 종류 전체</option>
      <option value="analysis">지문분석 워크북</option>
      <option value="comprehensive">내용이해 워크북</option>
      <option value="paragraph">모의고사 유형</option>
      <option value="vocabulary">단어</option>
      <option value="sentence">문장</option>
      <option value="grammar">어법</option>
    </select>
  );
};

export default WorksheetSelectBar;
